var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-4 px-5",attrs:{"fluid":""}},[(this.getdatosUsuario.cargo == 'Jefe')?_c('span',[_c('TicketArea')],1):_vm._e(),(this.getdatosUsuario.cargo == 'Auxiliar')?_c('span',[_c('TicketAuxi')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }